<template>
  <div class="platform-identify" :class="{ 'platform-identify--readonly-view': platformIdentifyReadOnly }">
    <div class="platform-identify__body">
      <el-alert v-if="platformIdentifyReadOnly" type="info" :closable="false" show-icon style="margin-bottom: 12px">
        <template slot="title">
          <div>鉴别号：{{ dataInfo.inspectionNo || '-' }}</div>
          <span>当前安心购服务：{{ inspectionServiceTypeLabel(dataInfo.inspectionServiceType) }}</span>
          <div class="platform-identify-service-sub">{{ inspectionServiceTypeHint(dataInfo) }}</div>
        </template>
      </el-alert>
      <el-alert v-else-if="allowReissueAfterRollback" type="warning" :closable="false" show-icon style="margin-bottom: 12px">
        <template slot="title">
          <div>鉴别号：{{ dataInfo.inspectionNo || initialInspectionNo || '-' }}</div>
          <span>作业已回滚，可补传实物图后重新提交出具（与寄售/鉴别订单一致）</span>
          <div class="platform-identify-service-sub">结论仍为真品时，将保留买家已确认发货进度；若改为不通过/不符退回，会按新结论重走后续流程。</div>
        </template>
      </el-alert>
      <el-alert v-else type="info" :closable="false" show-icon style="margin-bottom: 12px">
        <template slot="title">
          <span>当前安心购服务：{{ inspectionServiceTypeLabel(dataInfo.inspectionServiceType) }}</span>
          <div class="platform-identify-service-sub">{{ inspectionServiceTypeHint(dataInfo) }}</div>
        </template>
      </el-alert>

      <el-form class="platform-identify-form" label-width="110px">
        <el-form-item label="平台鉴别">
          <el-radio v-model="ptjbVle" :label="0" :disabled="platformIdentifyReadOnly">需要鉴别</el-radio>
          <el-radio v-model="ptjbVle" :label="1" style="margin-left: 16px"
            :disabled="platformIdentifyReadOnly || editMode">不符退回</el-radio>
          <div class="platform-identify-hint">
            需要鉴别：查看图谱并给出真/假结果；不符退回：直接判定不通过并走退回/退款逻辑
          </div>
        </el-form-item>

        <template v-if="ptjbVle === 0">
          <el-divider content-position="left">样品信息</el-divider>

          <el-form-item label="类型">
            <el-radio-group v-model.number="identifySffz" :disabled="platformIdentifyReadOnly">
              <el-radio :label="0">分装</el-radio>
              <el-radio :label="1">不分装</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="批次">
            <el-radio-group v-model.number="identifyType2" :disabled="platformIdentifyReadOnly">
              <el-radio :label="0">有批次号</el-radio>
              <el-radio :label="1">无批次号</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item v-if="identifyType2 === 0" label="批次号">
            <el-input v-model="identifyBatchNum" placeholder="请输入批次号" maxlength="120" style="max-width: 360px"
              :disabled="platformIdentifyReadOnly"></el-input>
          </el-form-item>

          <el-form-item v-if="showRealPictureSection" label="实物图片" class="platform-identify-real-form-item">
            <div v-if="platformIdentifyReadOnly" class="platform-identify-readonly-imgs">
              <template v-if="identifyRealImgs.length">
                <el-image
                  v-for="(url, idx) in identifyRealImgs"
                  :key="'real-ro-' + idx"
                  class="platform-identify-readonly-imgs__item"
                  :src="url"
                  fit="cover"
                  :preview-src-list="identifyRealImgs"
                />
              </template>
              <span v-else class="platform-identify-hint">暂无</span>
            </div>
            <orderRealPictureUpload v-else v-model="identifyRealImgs" :max="8" :columns="4" compact />
          </el-form-item>

          <el-form-item label="瑕疵图片" class="platform-identify-real-form-item">
            <div v-if="platformIdentifyReadOnly" class="platform-identify-readonly-imgs">
              <template v-if="identifyDefectImgs.length">
                <el-image
                  v-for="(url, idx) in identifyDefectImgs"
                  :key="'defect-ro-' + idx"
                  class="platform-identify-readonly-imgs__item"
                  :src="url"
                  fit="cover"
                  :preview-src-list="identifyDefectImgs"
                />
              </template>
              <span v-else class="platform-identify-hint">暂无</span>
            </div>
            <orderRealPictureUpload v-else v-model="identifyDefectImgs" :max="9" :columns="4" compact />
          </el-form-item>

          <el-form-item label="余量图片" class="platform-identify-real-form-item">
            <div v-if="platformIdentifyReadOnly" class="platform-identify-readonly-imgs">
              <template v-if="identifyRemainImgs.length">
                <el-image
                  v-for="(url, idx) in identifyRemainImgs"
                  :key="'remain-ro-' + idx"
                  class="platform-identify-readonly-imgs__item"
                  :src="url"
                  fit="cover"
                  :preview-src-list="identifyRemainImgs"
                />
              </template>
              <span v-else class="platform-identify-hint">暂无</span>
            </div>
            <orderRealPictureUpload v-else v-model="identifyRemainImgs" :max="3" :columns="4" compact />
          </el-form-item>

          <template v-if="inspectIdentifyProfile(dataInfo).showLiquidBlock">
            <el-row :gutter="16">
              <el-col :span="8">
                <el-form-item label="标准乙醇">
                  <el-input v-model="identifyBzyc" placeholder="标准乙醇" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="乙醇含量">
                  <el-input v-model="identifyYchl" placeholder="乙醇含量" :disabled="platformIdentifyReadOnly"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="标准图谱">
              <div v-if="!platformIdentifyReadOnly" class="platform-identify-actions">
                <!-- 暂不展示无坐标图谱
                <uploadFile @getImg="onStdChartNoCoordUploaded" :isSlot="true">
                  <el-button type="success" size="small">更改无坐标图谱</el-button>
                </uploadFile>
                -->
                <uploadFile @getImg="onStdChartCoordUploaded" :isSlot="true" :useCompress="true">
                  <el-button type="success" size="small">更改有坐标图谱</el-button>
                </uploadFile>
              </div>
              <div class="platform-identify-std-preview">
                <!-- 暂不展示无坐标图谱
                <div class="platform-identify-std-preview__item">
                  <div class="platform-identify-std-preview__label">无坐标图谱</div>
                  <div class="platform-identify-std-preview__thumb">
                    <el-image v-if="stdChartNoCoord" class="platform-identify-std-preview__img" :src="stdChartNoCoord"
                      fit="contain" :preview-src-list="[stdChartNoCoord]" />
                    <div v-else class="platform-identify-std-preview__empty">暂无图片</div>
                  </div>
                </div>
                -->
                <div class="platform-identify-std-preview__item">
                  <div class="platform-identify-std-preview__label">有坐标图谱</div>
                  <div class="platform-identify-std-preview__thumb">
                    <el-image v-if="stdChartCoord" class="platform-identify-std-preview__img" :src="stdChartCoord"
                      fit="contain" :preview-src-list="[stdChartCoord]" />
                    <div v-else class="platform-identify-std-preview__empty">暂无图片</div>
                  </div>
                </div>
              </div>
              <div class="platform-identify-hint">
                当前：有坐标 {{ stdChartCoord ? "已上传" : "未上传" }}
              </div>
            </el-form-item>

            <el-form-item label="鉴别图谱">
              <div v-if="!platformIdentifyReadOnly" class="platform-identify-jbtp-toolbar">
                <el-radio-group v-model="identifyChartUploadMode" size="small">
                  <el-radio-button label="image">上传图片</el-radio-button>
                  <el-radio-button label="txt">TXT 生成谱图</el-radio-button>
                </el-radio-group>
                <template v-if="identifyChartUploadMode === 'image'">
                  <el-upload class="platform-identify-jbtp-upload" name="file" :show-file-list="false"
                    :http-request="uploadIdentifyChartRequest">
                    <el-button type="success" size="small">{{ identifyList.jbtp ? "更换图片" : "上传图片" }}</el-button>
                  </el-upload>
                </template>
                <template v-else>
                  <el-button type="primary" size="small" plain :loading="identifyTxtGenerating"
                    @click="triggerIdentifySpectrumTxtPick">选择 TXT 并生成谱图</el-button>
                  <input ref="identifySpectrumTxtInput" type="file" accept=".txt,text/plain"
                    class="platform-identify-txt-input" @change="onIdentifySpectrumTxtSelected" />
                </template>
              </div>
              <div class="platform-identify-std-preview platform-identify-jbtp-preview-row">
                <div class="platform-identify-std-preview__item">
                  <div class="platform-identify-std-preview__thumb">
                    <el-image v-if="identifyList.jbtp" class="platform-identify-std-preview__img"
                      :src="identifyList.jbtp" fit="contain" :preview-src-list="[identifyList.jbtp]" />
                    <div v-else class="platform-identify-std-preview__empty">暂无图片</div>
                  </div>
                </div>
              </div>
              <div v-if="!inspectIdentifyProfile(dataInfo).requireJbtpWhenNormal" class="platform-identify-hint">
                外观鉴别档：可不传</div>
            </el-form-item>

            <el-form-item v-if="!platformIdentifyReadOnly" label="谱图相似度">
              <div class="spectrum-sim-toolbar">
                <el-button type="primary" size="small" :loading="spectrumSimLoading"
                  :disabled="!inspectionJobId" @click="runSpectrumSimilarityByJob">开始对比</el-button>
              </div>
              <div v-if="spectrumSimResult" class="spectrum-sim-result"
                :class="spectrumResultToneClass(spectrumSimResult)">
                <div class="spectrum-sim-result__title">
                  {{ formatSpectrumSimTitle(spectrumSimResult) }}
                </div>
                <div class="spectrum-sim-result__score">
                  图谱相似程度 <strong>{{ formatSpectrumMatchPercent(spectrumSimResult.similarityScore) }}</strong>
                  <span class="spectrum-sim-result__line">（≥ {{ formatSpectrumMatchPercent(spectrumSimResult.threshold) }} 视为较接近；≥ 90% 且走势很像也可人工审核）</span>
                </div>
                <div v-if="spectrumSimResult.ethanolDiffPct != null" class="spectrum-sim-result__score">
                  酒精浓度差 <strong>{{ Number(spectrumSimResult.ethanolDiffPct).toFixed(1) }}%</strong>
                  <span class="spectrum-sim-result__line">
                    （本次 {{ spectrumSimResult.ychl }}% / 标准 {{ spectrumSimResult.bzyc }}%，差小于 {{ spectrumSimResult.ethanolDiffLimitPct || ETHANOL_DIFF_PERCENT_LIMIT }}% 算正常）
                  </span>
                </div>
                <div class="spectrum-sim-result__hint">
                  {{ formatSpectrumSimHint(spectrumSimResult) }}
                </div>
              </div>
              <div class="platform-identify-hint">
                以上只是系统自动对比，帮你参考。相似≠一定是真货，不相似≠一定是假货。请对照标准图谱看完后，再人工选择液体鉴别结果。
              </div>
            </el-form-item>
          </template>

          <el-divider content-position="left">鉴别结果</el-divider>

          <el-form-item label="外观鉴别结果">
            <el-radio v-model="jbjgAppearanceVle" :label="1" :disabled="platformIdentifyReadOnly">通过</el-radio>
            <el-radio v-model="jbjgAppearanceVle" :label="0" style="margin-left: 16px"
              :disabled="platformIdentifyReadOnly">不通过</el-radio>
            <div v-if="appearanceResultLocked && !platformIdentifyReadOnly" class="platform-identify-hint">
              小程序已录入外观结论，可在此修改后继续液体鉴别
            </div>
          </el-form-item>
          <el-form-item
            v-if="inspectIdentifyProfile(dataInfo).showLiquidBlock"
            label="液体鉴别结果">
            <el-radio v-model="jbjgLiquidVle" :label="1" :disabled="platformIdentifyReadOnly">通过</el-radio>
            <el-radio v-model="jbjgLiquidVle" :label="0" style="margin-left: 16px"
              :disabled="platformIdentifyReadOnly">不通过</el-radio>
          </el-form-item>
        </template>

        <template v-else>
          <el-form-item label="退回原因">
            <el-radio-group v-model="issueDescChoice" class="issue-desc-radio-group"
              :disabled="platformIdentifyReadOnly">
              <el-radio v-for="item in issueDescOptionList" :key="item.value" :label="item.value"
                class="issue-desc-radio">{{ item.label }}</el-radio>
            </el-radio-group>
            <el-input v-if="issueDescChoice === issueDescCustomValue" v-model="issueDescCustomText" type="textarea"
              :rows="3" maxlength="120" show-word-limit placeholder="请填写具体退回原因" class="issue-desc-custom-input"
              :disabled="platformIdentifyReadOnly" />
          </el-form-item>
        </template>
      </el-form>

      <template v-if="platformIdentifyReadOnly">
        <div style="height: 12px" />
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="订单号">{{ dataInfo && dataInfo.orderNo }}</el-descriptions-item>
          <el-descriptions-item label="安心购服务">{{ inspectionServiceTypeLabel(dataInfo && dataInfo.inspectionServiceType)
            }}</el-descriptions-item>
          <template v-if="ptjbVle === 1">
            <el-descriptions-item label="鉴别结果" :span="2">不符退回/无法鉴别</el-descriptions-item>
            <el-descriptions-item label="退回原因" :span="2">{{ issueDescPreviewText }}</el-descriptions-item>
          </template>
          <template v-else>
            <el-descriptions-item label="外观鉴别">{{ jbjgAppearanceVle === 1 ? '通过' : '不通过' }}</el-descriptions-item>
            <el-descriptions-item v-if="inspectIdentifyProfile(dataInfo).showLiquidBlock"
              label="液体鉴别">{{ jbjgLiquidVle === 1 ? '通过' : '不通过' }}</el-descriptions-item>
            <el-descriptions-item label="鉴别结果">{{ previewCombinedInspectionShort }}</el-descriptions-item>
          </template>
          <el-descriptions-item label="批次">{{ previewIdentifyBatchLine }}</el-descriptions-item>
          <el-descriptions-item v-if="inspectIdentifyProfile(dataInfo).showLiquidBlock" label="标准乙醇">{{ identifyBzyc ||
            '-' }}</el-descriptions-item>
          <el-descriptions-item v-if="inspectIdentifyProfile(dataInfo).showLiquidBlock" label="乙醇含量">{{ identifyYchl ||
            '-' }}</el-descriptions-item>
          <el-descriptions-item label="鉴别图谱">{{ identifyList.jbtp ? '已上传' : '未上传' }}</el-descriptions-item>
          <el-descriptions-item label="分装类型">{{ secondhandSffzLabel(identifySffz) }}</el-descriptions-item>
        </el-descriptions>
      </template>
    </div>

    <div class="platform-identify__footer">
      <el-button v-if="!platformIdentifyReadOnly" type="success" :loading="submitLoading"
        @click="submitInspection">{{ editMode ? '保存修改' : (allowReissueAfterRollback ? '重新提交出具' : '提交出具') }}</el-button>
      <el-button @click="handleCancel">关闭</el-button>
    </div>
  </div>
</template>

<script>
import uploadFile from "@/components/elUpload";
import orderRealPictureUpload from "@/components/orderRealPictureUpload";
import { api } from "@/util/requestUrl";
import { parseRealPictureUrls } from "@/util/orderRealPicture";
import {
  SPECTRUM_TXT_MAX_POINTS,
  parseSpectrumTxt,
  downsampleSpectrumPairs,
  renderTxtSpectrumChartToDataUrlAsync,
} from "@/util/spectrumTxtChart";
import {
  ETHANOL_DIFF_PERCENT_LIMIT,
  parseEthanolFromFileName,
  evaluateEthanolDiff,
} from "@/util/ethanolSpectrumGate";
import { uploadImageWithCompressFallback } from "@/util/uploadImageWithCompressFallback";

const ISSUE_DESC_CUSTOM = "custom";

export default {
  components: {
    uploadFile,
    orderRealPictureUpload,
  },
  props: {
    orderId: {
      type: [Number, String],
      default: null,
    },
    /** 鉴别作业 ID（谱图相似度「开始对比」需要） */
    inspectionJobId: {
      type: [Number, String],
      default: null,
    },
    /** 鉴别作业列表带入：作业 inspectionType（1/2=外观+液体，3=仅外观） */
    initialInspectionType: {
      type: [Number, String],
      default: null,
    },
    initialInspectionNo: {
      type: String,
      default: null,
    },
    /** 报告已出具后的修改模式 */
    editMode: {
      type: Boolean,
      default: false,
    },
    /** 作业列表带入的作业状态：1/2 时允许在已出报告后重新出具 */
    initialJobStatus: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      ETHANOL_DIFF_PERCENT_LIMIT,
      dataInfo: {},
      submitLoading: false,

      platformIdentifyReadOnly: false,
      platformReportImg: "",

      ptjbVle: 0,
      jbjgAppearanceVle: 1,
      jbjgLiquidVle: 1,

      stdChartNoCoord: "",
      stdChartCoord: "",
      identifyList: {
        jbtp: "",
      },
      identifyChartUploadMode: "image",
      identifyTxtGenerating: false,
      /** 本页「TXT 生成谱图」选中的测样，开始对比时优先作为 testFile 上传 */
      simTestFile: null,
      spectrumSimLoading: false,
      spectrumSimResult: null,
      identifySffz: 1,
      identifyType2: 0,
      identifyBatchNum: "",
      identifyYchl: "",
      identifyBzyc: "",

      identifyRealImgs: [],
      identifyDefectImgs: [],
      identifyRemainImgs: [],

      issueDescChoice: "香水与下单信息不符",
      issueDescCustomText: "",
      issueDescCustomValue: ISSUE_DESC_CUSTOM,

      issueDescOptionList: [
        { value: "香水与下单信息不符", label: "香水与下单信息不符" },
        { value: "严重破损", label: "严重破损" },
        { value: "严重漏液", label: "严重漏液" },
        { value: "喷头损坏，无法取样", label: "喷头损坏，无法取样" },
        { value: ISSUE_DESC_CUSTOM, label: "自定义" },
      ],

      uploadUrl: api.uploadImgCompress,
    };
  },
  computed: {
    /** 作业回滚到平台鉴别中/待出具，且订单侧已出过报告 → 允许再次编辑提交 */
    allowReissueAfterRollback() {
      if (this.editMode) return false;
      const st = this.initialJobStatus != null ? Number(this.initialJobStatus) : null;
      if (st !== 1 && st !== 2) return false;
      return !!(this.dataInfo && this.dataInfo.inspectionReportAt);
    },
    showRealPictureSection() {
      if (this.editMode || this.allowReissueAfterRollback) return true;
      if (Number(this.identifySffz) === 1) return true;
      return (this.identifyRealImgs || []).length > 0;
    },
    issueDescPreviewText() {
      return this.issueDescChoice === ISSUE_DESC_CUSTOM ? this.issueDescCustomText : this.issueDescChoice;
    },
    previewCombinedInspectionShort() {
      if (this.ptjbVle === 1) return "不符退回";
      const appPass = this.jbjgAppearanceVle === 1;
      const liqPass = this.jbjgLiquidVle === 1;
      if (this.inspectIdentifyProfile(this.dataInfo).showLiquidBlock) {
        return appPass && liqPass ? "通过" : "不通过";
      }
      return appPass ? "通过" : "不通过";
    },
    previewIdentifyBatchLine() {
      if (Number(this.identifyType2) === 1) return "无批次号";
      return this.identifyBatchNum || "-";
    },
    appearanceResultLocked() {
      const appIr = this.dataInfo && this.dataInfo.inspectionResultAppearance;
      return appIr === 1 || appIr === 2;
    },
  },
  watch: {
    orderId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.loadData();
        }
      },
    },
  },
  methods: {
    loadData() {
      this.$https(api.getSecondhandOrderById, { id: this.orderId }, "GET")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            const order = res.data.data || {};
            this.dataInfo = {
              ...order,
              inspectionType:
                order.inspectionType != null && order.inspectionType !== ""
                  ? order.inspectionType
                  : this.initialInspectionType,
              inspectionNo: this.initialInspectionNo || order.inspectionNo,
            };
            this.openPlatformIdentify();
          } else {
            this.$message.error((res.data && res.data.msg) || "加载失败");
          }
        })
        .catch(() => {
          this.$message.error("加载订单失败，请稍后重试");
        });
    },

    /**
     * 打开平台鉴别弹窗：标准图谱优先订单已存列，其次历史 JSON，再其次商品关联型号 Type.atlas1/atlas2
     */
    openPlatformIdentify() {
      if (!this.dataInfo || !this.dataInfo.id) return;
      const d = this.dataInfo;
      const typeId = d.product && d.product.typeId;
      if (typeId) {
        this.$https(api.selType, { id: typeId, page: 1, size: 1 }, "POST")
          .then((res) => {
            let a1 = "";
            let a2 = "";
            let typeBzyc = "";
            if (res.data && Number(res.data.code) === 200 && Array.isArray(res.data.data) && res.data.data.length) {
              const row = res.data.data[0];
              a1 = row.atlas1 != null ? String(row.atlas1).trim() : "";
              a2 = row.atlas2 != null ? String(row.atlas2).trim() : "";
              typeBzyc = row.bzyc != null ? String(row.bzyc).trim() : "";
            }
            this.applyPlatformIdentifyFormState(d, a1, a2, typeBzyc);
          })
          .catch(() => {
            this.applyPlatformIdentifyFormState(d, "", "", "");
          });
      } else {
        this.applyPlatformIdentifyFormState(d, "", "", "");
      }
    },

    /**
     * 安全解析 JSON
     */
    safeJsonParse(str) {
      if (!str) return null;
      try {
        return JSON.parse(String(str));
      } catch (e) {
        return null;
      }
    },

    normalizeChartUrl(url) {
      if (!url) return "";
      const s = String(url).trim();
      if (!s) return "";
      if (/^https?:\/\//i.test(s)) return s;
      const base = "https://hzshixiang.site";
      return s.startsWith("/") ? base + s : base + "/" + s;
    },

    isNoXyChartUrl(url) {
      return /_NoXY/i.test(String(url || ""));
    },

    /** 兼容历史旧约定（a1无/a2有）与型号新约定（a1有/a2无） */
    splitStdChartsFromAtlasPair(atlas1, atlas2) {
      const u1 = atlas1 != null ? String(atlas1).trim() : "";
      const u2 = atlas2 != null ? String(atlas2).trim() : "";
      if (!u1 && !u2) return { stdCoord: "", stdNo: "" };
      if (u1 && u2) {
        const n1 = this.isNoXyChartUrl(u1);
        const n2 = this.isNoXyChartUrl(u2);
        if (n1 && !n2) return { stdCoord: u2, stdNo: u1 };
        if (!n1 && n2) return { stdCoord: u1, stdNo: u2 };
        return { stdCoord: u1, stdNo: u2 };
      }
      if (u1) {
        return this.isNoXyChartUrl(u1)
          ? { stdCoord: "", stdNo: u1 }
          : { stdCoord: u1, stdNo: "" };
      }
      return this.isNoXyChartUrl(u2)
        ? { stdCoord: "", stdNo: u2 }
        : { stdCoord: u2, stdNo: "" };
    },

    /**
     * 应用平台鉴别表单状态：标准图谱优先级：订单已保存 > JSON报告 > 商品型号
     */
    applyPlatformIdentifyFormState(d, typeAtlas1, typeAtlas2, typeBzyc) {
      if (!d || !d.id) return;

      // 报告已出具后默认只读；作业回滚到 1/2（待鉴别/待出具）时可重新出具，与寄售鉴别一致
      const jobSt = this.initialJobStatus != null ? Number(this.initialJobStatus) : null;
      const jobAllowsReissue = jobSt === 1 || jobSt === 2;
      this.platformIdentifyReadOnly =
        !!(d.inspectionReportAt) && !this.editMode && !jobAllowsReissue;
      this.platformReportImg = d.inspectionReportUrl || "";

      // 鉴别结果
      const appIr = d.inspectionResultAppearance;
      const liqIr = d.inspectionResultLiquid;
      if (appIr != null && (appIr === 1 || appIr === 2)) {
        this.jbjgAppearanceVle = appIr === 2 ? 0 : 1;
      } else {
        const ir = Number(d.inspectionResult || 0);
        this.jbjgAppearanceVle = ir === 2 ? 0 : 1;
      }
      if (liqIr != null && (liqIr === 1 || liqIr === 2)) {
        this.jbjgLiquidVle = liqIr === 2 ? 0 : 1;
      } else {
        const ir = Number(d.inspectionResult || 0);
        this.jbjgLiquidVle = ir === 2 ? 0 : 1;
      }

      // 平台鉴别类型：已出具不符退回时回填 ptjb=1
      const payloadForPtjb = this.safeJsonParse(d.inspectionReportJson);
      const irCombined = Number(d.inspectionResult || 0);
      if (irCombined === 3 || (payloadForPtjb && Number(payloadForPtjb.ptjb) === 1)) {
        this.ptjbVle = 1;
        const savedDesc = d.inspectionIssueDesc || (payloadForPtjb && payloadForPtjb.issue && payloadForPtjb.issue.desc);
        if (savedDesc) {
          const descStr = String(savedDesc).trim();
          const preset = this.issueDescOptionList.find((o) => o.value === descStr);
          if (preset && preset.value !== ISSUE_DESC_CUSTOM) {
            this.issueDescChoice = preset.value;
            this.issueDescCustomText = "";
          } else {
            this.issueDescChoice = ISSUE_DESC_CUSTOM;
            this.issueDescCustomText = descStr;
          }
        }
      } else {
        this.ptjbVle = 0;
      }

      // 标准图谱：优先级 订单已保存 > JSON报告 > 商品型号
      // 型号约定 atlas1=有坐标 / atlas2=无坐标；已存字段用文件名兼容新旧约定
      let { stdCoord, stdNo } = this.splitStdChartsFromAtlasPair(d.atlas1, d.atlas2);

      // 从历史 JSON 中解析（stdCoord/stdNoCoord 语义字段）
      const payload = this.safeJsonParse(d.inspectionReportJson);
      if (payload && payload.schema === "platform_identify_v1") {
        const ch = payload.charts || {};
        if (!stdNo && ch.stdNoCoord) stdNo = String(ch.stdNoCoord).trim();
        if (!stdCoord && ch.stdCoord) stdCoord = String(ch.stdCoord).trim();
      }

      // 从商品型号获取：a1有坐标、a2无坐标
      if (!stdCoord && typeAtlas1) stdCoord = String(typeAtlas1).trim();
      if (!stdNo && typeAtlas2) stdNo = String(typeAtlas2).trim();

      this.stdChartNoCoord = this.normalizeChartUrl(stdNo);
      this.stdChartCoord = this.normalizeChartUrl(stdCoord);

      // 鉴别图谱
      let jbtp = (d.jbtp && String(d.jbtp).trim()) || "";
      if (payload && payload.schema === "platform_identify_v1") {
        const ch = payload.charts || {};
        if (!jbtp && ch.identify) jbtp = String(ch.identify).trim();
      }
      this.identifyList = { jbtp: this.normalizeChartUrl(jbtp) };

      // 分装类型
      this.identifySffz = d.sffz != null ? Number(d.sffz) : 1;
      this.identifyType2 = d.type2 != null ? Number(d.type2) : 0;
      this.identifyBatchNum = d.batchNum || "";

      // 标准乙醇和乙醇含量：优先级 订单已保存 > JSON报告 > 商品型号
      let ychl = (d.ychl && String(d.ychl).trim()) || "";
      let bzyc = (d.bzyc && String(d.bzyc).trim()) || "";
      if (payload && payload.schema === "platform_identify_v1" && payload.meta) {
        if (!ychl && payload.meta.ychl) ychl = String(payload.meta.ychl).trim();
        if (!bzyc && payload.meta.bzyc) bzyc = String(payload.meta.bzyc).trim();
      }
      // 从商品型号获取标准乙醇
      if (!bzyc && typeBzyc) bzyc = String(typeBzyc).trim();
      this.identifyYchl = ychl;
      this.identifyBzyc = bzyc;

      // 实物图片
      this.identifyRealImgs = parseRealPictureUrls(d.realpicture).map((u) => this.normalizeChartUrl(u));
      this.identifyDefectImgs = parseRealPictureUrls(d.defectImgs).map((u) => this.normalizeChartUrl(u));
      this.identifyRemainImgs = parseRealPictureUrls(d.remainImgs).map((u) => this.normalizeChartUrl(u));

      this.identifyChartUploadMode = "image";
      this.identifyTxtGenerating = false;
    },

    initFormState() {
      // 保留兼容性，内部调用 applyPlatformIdentifyFormState
      this.applyPlatformIdentifyFormState(this.dataInfo, "", "", "");
    },

    inspectIdentifyProfile(detail) {
      const serviceType = String((detail && detail.inspectionServiceType) || "").trim();
      if (serviceType === "liq_app") {
        return { showLiquidBlock: true, requireJbtpWhenNormal: true };
      }
      if (serviceType === "app_only" || serviceType === "appearance_only") {
        return { showLiquidBlock: false, requireJbtpWhenNormal: false };
      }
      const inspectionType = Number(
        (detail && detail.inspectionType) != null && detail.inspectionType !== ""
          ? detail.inspectionType
          : this.initialInspectionType
      );
      const showLiquidBlock = inspectionType === 1 || inspectionType === 2;
      return { showLiquidBlock, requireJbtpWhenNormal: showLiquidBlock };
    },

    inspectionServiceTypeLabel(type) {
      const k = String(type || "").trim();
      if (k === "liq_app") return "外观+液体鉴别";
      if (k === "app_only" || k === "appearance_only") return "外观鉴别";
      const inspectionType = Number(
        (this.dataInfo && this.dataInfo.inspectionType) != null
          ? this.dataInfo.inspectionType
          : this.initialInspectionType
      );
      if (inspectionType === 1 || inspectionType === 2) return "外观+液体鉴别";
      if (inspectionType === 3) return "外观鉴别";
      return k || "-";
    },

    inspectionServiceTypeHint(detail) {
      const t = String((detail && detail.inspectionServiceType) || "").trim();
      if (t === "liq_app") return "需同时提供外观鉴别结论 + 液体鉴别结论";
      if (t === "app_only" || t === "appearance_only") return "仅需提供外观鉴别结论";
      const inspectionType = Number(
        (detail && detail.inspectionType) != null && detail.inspectionType !== ""
          ? detail.inspectionType
          : this.initialInspectionType
      );
      if (inspectionType === 1 || inspectionType === 2) {
        return "需同时提供外观鉴别结论 + 液体鉴别结论";
      }
      if (inspectionType === 3) return "仅需提供外观鉴别结论";
      return "未识别服务档时按外观鉴别处理";
    },

    secondhandSffzLabel(sffz) {
      return sffz === 0 ? "分装" : "不分装";
    },

    buildSamplePicturesPayload() {
      // 与瑕疵图/余量图、作业详情一致：数组整份落库（最多 8 张），不再压成 img1～img4
      return {
        realpicture: JSON.stringify(this.identifyRealImgs || []),
        defectImgs: JSON.stringify(this.identifyDefectImgs || []),
        remainImgs: JSON.stringify(this.identifyRemainImgs || []),
      };
    },

    onStdChartNoCoordUploaded(path) {
      this.stdChartNoCoord = this.normalizeChartUrl(path);
    },

    onStdChartCoordUploaded(path) {
      this.stdChartCoord = this.normalizeChartUrl(path);
    },

    onIdentifyChartUploaded(res) {
      const p =
        (res && res.data && res.data.path) ||
        (res && res.data && res.data.data && res.data.data.path) ||
        (res && res.path) ||
        "";
      if (p) {
        this.$set(this.identifyList, "jbtp", this.normalizeChartUrl(p));
        this.$message.success("上传成功");
      } else {
        this.$message.error("上传失败");
      }
    },

    async uploadIdentifyChartRequest(option) {
      try {
        const no = `${Date.now()}_${Math.round(Math.random() * 1000)}`;
        const result = await uploadImageWithCompressFallback(this.$https, option.file, {
          api,
          no,
        });
        if (!result.ok) {
          this.$message.error((result && result.msg) || "上传失败");
          if (typeof option.onError === "function") option.onError(new Error("fail"));
          return;
        }
        const body = result.body || { code: 0, data: result.data || { path: result.path } };
        this.onIdentifyChartUploaded(body);
        if (typeof option.onSuccess === "function") option.onSuccess(body);
      } catch (e) {
        this.$message.error("上传失败");
        if (typeof option.onError === "function") option.onError(e);
      }
    },

    triggerIdentifySpectrumTxtPick() {
      this.$refs.identifySpectrumTxtInput && this.$refs.identifySpectrumTxtInput.click();
    },

    runSpectrumSimilarityByJob() {
      if (!this.inspectionJobId) {
        this.$message.warning("缺少鉴别作业ID");
        return;
      }
      const form = new FormData();
      form.append("jobId", this.inspectionJobId);
      // 有本页选中的测样 TXT 则上传；否则后端用作业已存 jbtpFile。标样始终用型号已存。
      if (this.simTestFile) {
        form.append("testFile", this.simTestFile);
      }
      this.appendEthanolParams(form);
      this.postSpectrumSimilarity(form);
    },

    appendEthanolParams(form) {
      if (!form) return;
      if (this.identifyYchl) form.append("ychl", String(this.identifyYchl).trim());
      if (this.identifyBzyc) form.append("bzyc", String(this.identifyBzyc).trim());
    },

    applyEthanolFromTestFile(file) {
      const ychl = parseEthanolFromFileName(file && file.name);
      if (!ychl) {
        this.$message.warning("测样文件名建议为「鉴别号+酒精浓度.txt」，如 260728-1-16+73.3.txt");
        return { ok: false };
      }
      this.identifyYchl = ychl;
      const { fail, diffPct } = evaluateEthanolDiff(ychl, this.identifyBzyc);
      if (diffPct == null) {
        this.$message.warning(`已填入酒精浓度 ${ychl}%，但标准浓度无效，无法自动判定差异`);
        return { ok: true, ychl, diffPct: null };
      }
      if (fail) {
        this.$message.warning(
          `参考：酒精浓度差 ${diffPct.toFixed(1)}% ≥ ${ETHANOL_DIFF_PERCENT_LIMIT}%（本次 ${ychl}% / 标准 ${this.identifyBzyc}%），请对照图谱后选择结论`
        );
        return { ok: true, ychl, diffPct, failed: true };
      }
      this.$message.success(
        `已填入酒精浓度 ${ychl}%（与标准差 ${diffPct.toFixed(1)}%，未超 ${ETHANOL_DIFF_PERCENT_LIMIT}%）`
      );
      return { ok: true, ychl, diffPct, failed: false };
    },

    postSpectrumSimilarity(form) {
      this.spectrumSimLoading = true;
      this.$axios
        .post(api.compareSpectrumSimilarity, form, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          if (res.data && Number(res.data.code) === 200 && res.data.data) {
            const data = res.data.data;
            this.spectrumSimResult = data;
            if (data.ychl != null && data.ychl !== "") {
              this.identifyYchl = String(data.ychl);
            }
            if (data.ethanolPass === false) {
              this.$message.warning(data.verdict || "酒精浓度差偏大（仅参考），请人工选择液体结论");
            } else if (!data.pass) {
              this.$message.warning(data.verdict || "图谱不够接近（仅参考），请人工选择液体结论");
            } else {
              this.$message.success(res.data.msg || "比对完成");
            }
          } else {
            this.$message.error((res.data && res.data.msg) || "比对失败");
          }
        })
        .catch(() => {
          this.$message.error("网络异常");
        })
        .finally(() => {
          this.spectrumSimLoading = false;
        });
    },

    formatSpectrumMatchPercent(val) {
      const n = Number(val);
      if (!Number.isFinite(n)) return "-";
      const pct = Math.max(0, Math.min(100, n * 100));
      return pct.toFixed(2) + "%";
    },

    /**
     * 结果块色调：≥95% 绿；90%~95% 人工审核浅绿；90%~95% 未过 / 接近线 橙；
     * &lt;90% 红；酒精浓度差不通过独立琥珀色（不与图谱不像共用红）。
     */
    spectrumResultToneClass(res) {
      if (!res) return "";
      if (res.ethanolPass === false) return "is-ethanol-fail";
      const score = Number(res.similarityScore);
      if (!Number.isFinite(score)) return res.pass ? "is-pass" : "is-fail";
      if (score >= 0.95) return "is-pass";
      if (score >= 0.9) return res.pass ? "is-soft-pass" : "is-warn";
      return "is-fail";
    },

    formatSpectrumSimTitle(res) {
      if (!res) return "";
      if (res.ethanolPass === false) return "系统参考：酒精浓度差偏大";
      if (res.pass) {
        const score = Number(res.similarityScore);
        const th = Number(res.threshold);
        if (Number.isFinite(score) && Number.isFinite(th) && score < th) {
          return "系统参考：图谱较接近标准样（人工审核）";
        }
        return "系统参考：图谱较接近标准样";
      }
      return "系统参考：图谱不够接近，请对照图再判断";
    },

    /** 主区白话提示：普通人可读 */
    formatSpectrumSimHint(res) {
      if (!res) return "";
      if (res.ethanolPass === false) {
        const diff = res.ethanolDiffPct != null ? Number(res.ethanolDiffPct).toFixed(1) : "-";
        return `酒精浓度差约 ${diff}%，偏大。请以人工判断为准。`;
      }
      if (res.pass) {
        const score = Number(res.similarityScore);
        const th = Number(res.threshold);
        if (Number.isFinite(score) && Number.isFinite(th) && score < th) {
          return "系统觉得走势接近标准样（相对高度略有差异，建议人工审核）。仍请看一眼峰的数量和有没有杂峰，再下结论。";
        }
        return "系统觉得图谱较接近标准样。仍请看一眼峰的数量和有没有杂峰，再下结论。";
      }
      const score = Number(res.similarityScore);
      const r = Number(res.pearsonR);
      if (Number.isFinite(score) && Number.isFinite(r) && r >= 0.9 && score < Number(res.threshold)) {
        return "峰的整体形状差不多，但高低比例还不够像，差一点点没到线。请对照标准图谱再确认。";
      }
      return "图谱和标准样差得比较明显。请对照标准图谱目视确认后再下结论。";
    },

    onIdentifySpectrumTxtSelected(ev) {
      const input = ev && ev.target;
      if (!input || !input.files || !input.files[0]) return;
      const file = input.files[0];
      input.value = "";
      const name = (file.name || "").toLowerCase();
      if (!name.endsWith(".txt")) {
        this.$message.warning("请选择 .txt 文本文件");
        return;
      }
      // 保留测样 TXT，供「开始对比」作为 testFile；并解析乙醇
      this.simTestFile = file;
      this.spectrumSimResult = null;
      this.applyEthanolFromTestFile(file);
      this.identifyTxtGenerating = true;
      const reader = new FileReader();
      reader.onload = () => {
        try {
          const text = String(reader.result || "");
          const rawPts = parseSpectrumTxt(text);
          if (rawPts.length < 2) {
            this.identifyTxtGenerating = false;
            this.$message.error("未能从 TXT 中解析出有效数据点，请检查是否为两列数值格式");
            return;
          }
          const pts = downsampleSpectrumPairs(rawPts, SPECTRUM_TXT_MAX_POINTS);
          renderTxtSpectrumChartToDataUrlAsync(pts)
            .then((dataUrl) => this.uploadIdentifyChartFromDataUrl(dataUrl))
            .then(() => {
              this.$message.success("谱图已生成并上传；测样 TXT 已保留供对比");
            })
            .catch((e) => {
              this.$message.error((e && e.message) || "谱图生成或上传失败");
            })
            .finally(() => {
              this.identifyTxtGenerating = false;
            });
        } catch (err) {
          this.identifyTxtGenerating = false;
          this.$message.error((err && err.message) || "生成谱图失败");
        }
      };
      reader.onerror = () => {
        this.identifyTxtGenerating = false;
        this.$message.error("读取文件失败");
      };
      reader.readAsText(file, "UTF-8");
    },

    dataURLtoFile(base64Str, fileName) {
      const arr = base64Str.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], fileName, { type: mime });
    },

    async uploadIdentifyChartFromDataUrl(dataUrl) {
      const no = new Date().valueOf() + "_" + Math.round(Math.random() * 1000);
      let imgFile;
      try {
        imgFile = this.dataURLtoFile(dataUrl, no + ".png");
      } catch (e) {
        throw new Error("图片数据转换失败");
      }
      const result = await uploadImageWithCompressFallback(this.$https, imgFile, {
        api,
        no,
      });
      if (result.ok && result.path) {
        this.$set(this.identifyList, "jbtp", this.normalizeChartUrl(result.path));
        return result.path;
      }
      throw new Error((result && result.msg) || "上传失败");
    },

    handleCancel() {
      this.$emit("close");
    },

    resolveIssueDescForSubmit() {
      if (this.ptjbVle !== 1) return null;
      if (this.issueDescChoice === ISSUE_DESC_CUSTOM) {
        return String(this.issueDescCustomText || "").trim();
      }
      return String(this.issueDescChoice || "").trim();
    },

    submitInspection() {
      if (this.platformIdentifyReadOnly) {
        return;
      }
      if (this.editMode && this.ptjbVle === 1) {
        this.$message.warning("修改模式下不可变更为不符退回");
        return;
      }

      const isMismatch = this.ptjbVle === 1;
      const showLiquid = this.inspectIdentifyProfile(this.dataInfo).showLiquidBlock;
      const serviceType = String((this.dataInfo && this.dataInfo.inspectionServiceType) || "").trim();

      if (isMismatch) {
        const desc = this.resolveIssueDescForSubmit();
        if (!desc) {
          this.$message.error(
            this.issueDescChoice === ISSUE_DESC_CUSTOM ? "请填写自定义退回原因" : "请选择退回原因"
          );
          return;
        }
        if (this.issueDescChoice === ISSUE_DESC_CUSTOM && desc.length > 120) {
          this.$message.error("自定义退回原因最多120字");
          return;
        }
      } else if (showLiquid && this.jbjgLiquidVle === 1 && !this.identifyList.jbtp) {
        this.$message.warning("液体鉴别通过时请先上传鉴别图谱");
        return;
      }

      const inspectionResultAppearance = isMismatch
        ? null
        : (this.jbjgAppearanceVle === 1 ? 1 : 2);
      const inspectionResultLiquid =
        isMismatch || serviceType !== "liq_app"
          ? null
          : (this.jbjgLiquidVle === 1 ? 1 : 2);
      const inspectionResult = isMismatch
        ? 3
        : serviceType === "liq_app"
          ? (this.jbjgAppearanceVle === 1 && this.jbjgLiquidVle === 1 ? 1 : 2)
          : (this.jbjgAppearanceVle === 1 ? 1 : 2);

      const issueDesc = isMismatch ? this.resolveIssueDescForSubmit() : null;
      const payloadJson = {
        schema: "platform_identify_v1",
        ptjb: this.ptjbVle,
        issue: isMismatch ? { type: 0, desc: issueDesc } : undefined,
        charts: {
          stdNoCoord: this.stdChartNoCoord,
          stdCoord: this.stdChartCoord,
          identify: this.identifyList.jbtp,
        },
        meta: {
          sffz: this.identifySffz,
          type2: this.identifyType2,
          batchNum: Number(this.identifyType2) === 1 ? "" : String(this.identifyBatchNum || "").trim(),
          ychl: this.identifyYchl,
          bzyc: this.identifyBzyc,
        },
      };

      this.submitLoading = true;
      const submitUrl = this.editMode ? api.updateInspectionReport : api.submitInspectionReport;
      this.$https(
        submitUrl,
        {
          orderId: this.orderId,
          inspectionResult,
          inspectionResultAppearance,
          inspectionResultLiquid,
          inspectionReportJson: JSON.stringify(payloadJson),
          inspectionIssueType: this.ptjbVle === 1 ? 0 : null,
          inspectionIssueDesc: issueDesc,
          atlas1: this.stdChartCoord || "",
          atlas2: this.stdChartNoCoord || "",
          jbtp: this.identifyList.jbtp || "",
          type2: this.identifyType2,
          batchNum: Number(this.identifyType2) === 1 ? "" : String(this.identifyBatchNum || "").trim(),
          ychl: this.identifyYchl || "",
          bzyc: this.identifyBzyc || "",
          ...this.buildSamplePicturesPayload(),
        },
        "POST"
      )
        .then((res) => {
          if (res.data && res.data.code === 200) {
            this.$message.success(this.editMode ? "修改成功" : "提交成功");
            this.$emit("success");
          } else {
            this.$message.error(res.data.msg || (this.editMode ? "修改失败" : "提交失败"));
          }
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.platform-identify {
  display: flex;
  flex-direction: column;
  max-height: calc(95vh - 130px);
  min-height: 0;
  padding: 0 8px;
}

.platform-identify__body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.platform-identify__footer {
  flex-shrink: 0;
  padding: 12px 0 4px;
  text-align: right;
  border-top: 1px solid #ebeef5;
  background: #fff;
}

.platform-identify-form {
  margin-top: 8px;
}

.platform-identify-hint {
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
  margin-top: 4px;
}

.platform-identify-service-sub {
  font-size: 12px;
  color: #909399;
  margin-top: 2px;
}

.platform-identify-actions {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
  text-align: center;
}

.platform-identify-std-preview {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 8px;
}

.platform-identify-std-preview__item {
  flex: 1;
}

.platform-identify-std-preview__label {
  font-size: 12px;
  color: #606266;
  margin-bottom: 4px;
  text-align: center;
}

.platform-identify-std-preview__thumb {
  max-width: 95%;
  height: 180px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.platform-identify-std-preview__img {
  width: 100%;
  height: 100%;
}

.platform-identify-std-preview__empty {
  color: #c0c4cc;
  font-size: 12px;
}

.platform-identify-jbtp-toolbar {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 8px;
}

.platform-identify-jbtp-upload {
  display: inline-block;
}

.platform-identify-txt-input {
  display: none;
}

.spectrum-sim-toolbar {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 8px;
}

.spectrum-sim-result {
  margin-top: 6px;
  padding: 10px 12px;
  border-radius: 4px;
  font-size: 13px;
  line-height: 1.6;
  max-width: 560px;
}

.spectrum-sim-result__title {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 4px;
  color: inherit;
}

.spectrum-sim-result__score {
  margin-bottom: 4px;
  color: inherit;
}

.spectrum-sim-result__score strong {
  font-size: 18px;
  color: inherit;
}

.spectrum-sim-result__line {
  color: inherit;
  opacity: 0.85;
  font-size: 12px;
}

.spectrum-sim-result__hint {
  font-size: 12px;
  opacity: 0.9;
  margin-bottom: 4px;
}

/* ≥95% 硬过线 */
.spectrum-sim-result.is-pass {
  background: #f0f9eb;
  color: #67c23a;
  border: 1px solid #e1f3d8;
}

/* 90%~95% 人工审核 */
.spectrum-sim-result.is-soft-pass {
  background: #f0f9eb;
  color: #529b2e;
  border: 1px solid #e1f3d8;
}

/* 90%~95% 未过人工审核档 / 接近线未过 */
.spectrum-sim-result.is-warn {
  background: #fdf6ec;
  color: #e6a23c;
  border: 1px solid #faecd8;
}

/* <90% 图谱差得较明显 */
.spectrum-sim-result.is-fail {
  background: #fef0f0;
  color: #f56c6c;
  border: 1px solid #fde2e2;
}

/* 酒精浓度差闸门：独立琥珀色，不与图谱不像共用红 */
.spectrum-sim-result.is-ethanol-fail {
  background: #fdf6ec;
  color: #b88230;
  border: 1px solid #faecd8;
}

.platform-identify-jbtp-preview-row {
  margin-top: 8px;
}

.platform-identify-real-form-item {
  margin-bottom: 0;
}

.platform-identify-real-strip {
  display: flex;
  gap: 12px;
}

.platform-identify-real-slot {
  text-align: center;
}

.platform-identify-real-slot__cap {
  font-size: 12px;
  color: #606266;
  margin-bottom: 4px;
}

.platform-identify-real-slot__box {
  width: 80px;
  height: 80px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
}

.platform-identify-real-slot__upload {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.platform-identify-real-slot__empty {
  color: #c0c4cc;
  font-size: 12px;
}

.issue-desc-radio-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.issue-desc-radio {
  margin-left: 0 !important;
}

.issue-desc-custom-input {
  margin-top: 8px;
  max-width: 400px;
}

.platform-identify-readonly-imgs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.platform-identify-readonly-imgs__item {
  width: 76px;
  height: 76px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e4e7ed;
}
</style>



// WEBPACK FOOTER //
// src/pages/inspectionJob/secondHandVerify.vue